/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum MyChartPastHistoryPatientAliases {
  ACTION_DELETE = 'action-delete',
  ACTION_INACTIVATE = 'action-inactivate',
  ACTION_RELEASE = 'action-release',
  CONTEXTUAL_BAR_PAST_HISTORY_PATIENT = 'contextual-bar-past-history-patient',
  DATE_FIELD_END_DATE = 'date-field-end-date',
  DATE_FIELD_START_DATE = 'date-field-start-date',
  FIELD_DISEASE = 'field-disease',
  FIELD_END_DATE = 'field-end-date',
  FIELD_END_DATE_DETAIL = 'field-end-date-detail',
  FIELD_INACTIVATE_DATE = 'field-inactivate-date',
  FIELD_NOTES = 'field-notes',
  FIELD_RELEASE_DATE = 'field-release-date',
  FIELD_START_DATE = 'field-start-date',
  FIELD_START_DATE_DETAIL = 'field-start-date-detail',
  FORM_PAST_HISTORY_PATIENT = 'form-past-history-patient',
  INPUT_DISEASE = 'input-disease',
  INPUT_END_DATE_DETAIL = 'input-end-date-detail',
  INPUT_INACTIVATE_DATE = 'input-inactivate-date',
  INPUT_RELEASE_DATE = 'input-release-date',
  INPUT_START_DATE_DETAIL = 'input-start-date-detail',
  LAYOUT_PAST_HISTORY_PATIENT = 'layout-past-history-patient',
  PANEL_PAST_HISTORY_PATIENT = 'panel-past-history-patient',
  TEXT_NOTES = 'text-notes',
}
export { MyChartPastHistoryPatientAliases };
